module.exports = __webpack_public_path__ + "img/wa-line5.fc7b217.png";